(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-hero"] && !Shopify.designMode) return;
  try {
    
  /*
    Category links ("#skincare" etc.) jump to the section with that Anchor ID.
    On desktop the page scrolls inside .page-wrapper rather than the window, and
    the browser's native hash jump does not reliably scroll it, so scroll the
    target into view ourselves - on click, and on load when the URL already has
    a matching hash. .beauty-anchor's scroll-margin-top keeps it below the header.
  */
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const scrollToAnchor = (id, behavior) => {
      const target = id && document.getElementById(id);
      if (!target || !target.classList.contains('beauty-anchor')) return false;
      target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : behavior, block: 'start' });
      return true;
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('.beauty-hero__bar-item[href^="#"]');
      if (!link) return;
      const id = decodeURIComponent(link.getAttribute('href').slice(1));
      if (!scrollToAnchor(id, 'smooth')) return;
      event.preventDefault();
      history.replaceState(null, '', '#' + id);
    });

    const scrollToCurrentHash = () => scrollToAnchor(decodeURIComponent(location.hash.slice(1)), 'auto');
    if (document.readyState === 'complete') scrollToCurrentHash();
    else window.addEventListener('load', scrollToCurrentHash, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["houseware-hotspots"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('houseware-hotspots')) {
    customElements.define('houseware-hotspots', class extends HTMLElement {
      connectedCallback() {
        this.spots = Array.from(this.querySelectorAll('[data-spot]'));
        this.card = this.querySelector('[data-card]');
        if (!this.card) return;
        this.nameEl = this.card.querySelector('[data-card-name]');
        this.lineEl = this.card.querySelector('[data-card-line]');
        this.ctaEl = this.card.querySelector('[data-card-cta]');
        this.spots.forEach((b, i) => b.addEventListener('click', () => this.set(i)));
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.spots.indexOf(e.target);
          if (i > -1) this.set(i);
        });
      }
      set(i) {
        const b = this.spots[i];
        if (!b) return;
        this.spots.forEach((s, j) => {
          s.classList.toggle('is-active', j === i);
          s.setAttribute('aria-pressed', j === i ? 'true' : 'false');
        });
        this.nameEl.textContent = b.dataset.name;
        this.lineEl.textContent = b.dataset.line;
        this.ctaEl.textContent = b.dataset.cta;
        this.ctaEl.hidden = !b.dataset.cta;
        this.ctaEl.href = b.dataset.url || '#';
        if (b.dataset.newTab === 'true') {
          this.ctaEl.target = '_blank';
          this.ctaEl.rel = 'noopener';
        } else {
          this.ctaEl.removeAttribute('target');
          this.ctaEl.removeAttribute('rel');
        }
        const x = parseFloat(b.dataset.x), y = parseFloat(b.dataset.y);
        const left = x > 55 ? 'calc(' + x + '% - 384px)' : 'calc(' + x + '% + 36px)';
        const top = 'calc(' + Math.min(Math.max(y, 12), 70) + '% - 60px)';
        this.card.style.setProperty('--houseware-card-left', left);
        this.card.style.setProperty('--houseware-card-top', top);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
